import React from 'react';
import './ViewPayments.css';

const ViewPayments = () => {
  return (
    <div className="content-box animated">
      <h3>View Payments</h3>
      <p>Below is a list of recent payments made on the platform.</p>
      <table className="payments-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>User ID</th>
            <th>User</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>2024-10-01</td>
            <td>U001</td>
            <td>John Doe</td>
            <td>$49.99</td>
            <td>Completed</td>
          </tr>
          <tr>
            <td>2024-10-02</td>
            <td>U002</td>
            <td>Jane Smith</td>
            <td>$19.99</td>
            <td>Pending</td>
          </tr>
          <tr>
            <td>2024-10-03</td>
            <td>U003</td>
            <td>Sam Wilson</td>
            <td>$99.99</td>
            <td>Completed</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ViewPayments;
